import * as actionTypes from "../consts/actionTypes";

/**acciones que se disparan del componente */
export function getAllCredentialsAction(numeroPersona) {
    return {
        type: actionTypes.GET_ALL_CREDENTIALS,
        payload: numeroPersona,
    };
}